export const METRICS_EVENT_MANUAL = 'METRICS_EVENT_MANUAL';
export const METRICS_IDENTIFY = 'METRICS_IDENTIFY';
